'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidHistoryMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _mockData = require('./mockData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidHistoryMock = exports.BidHistoryMock = {
    fetchBidHistory: function fetchBidHistory(catalogId) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var bidHistory = (0, _mockData.getTestBidHistory)(catalogId);
                resolve({
                    data: bidHistory.history
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/bidHistory.js
// module id = BK5P
// module chunks = 57